import { Box, buildPath, buildTemplatePath, Page, PageRoute, Stack, Typography } from "@compass/core";
import SentimentVerySatisfiedIcon from "@mui/icons-material/SentimentVerySatisfied";

const routeName = "thankYou";

export const thankYouPageRoute: PageRoute = {
  handle: "thankYou",
  templatePath: buildTemplatePath(routeName),
  getPath: () => buildPath(routeName),
};

export const ThankYouPage = () => {
  return (
    <Stack alignItems="center" justifyContent="center" height="100vh">
      <SentimentVerySatisfiedIcon sx={{ fontSize: "200px" }} color="success" />
      <Typography variant="h1" color="success">
        Thank you
      </Typography>
    </Stack>
  );
};
